/**
 * 341: how a permission's scope reads on the Roles pages. `own_assigned_cars` (303) used to fall through to "any", so
 * a role builder could grant "read (any)" believing it covered everything when it covered only a host's own cars.
 */
const LABELS: Record<string, string> = {
  any: 'any',
  own_supplier: 'own supplier',
  own_assigned_cars: 'assigned cars',
};

export function scopeLabel(scope: string): string {
  return LABELS[scope] ?? scope.replaceAll('_', ' ');
}
